import { Board } from "../../common/boards/board.schema";
import { Event } from "../../common/events/event.schema";
import SummaryComplete from "./SummaryComplete";
import SummaryInProgress from "./SummaryInProgress";
import SummaryScheduled from "./SummaryScheduled";
const Summary = ({
  event,
  board,
  onSelectViewCurrent,
}: {
  event: Event;
  board: Board;
  onSelectViewCurrent?: () => void;
}) => {
  // console.log("canRegister :", canRegister);
  if (event.complete) return <SummaryComplete event={event} board={board} />;
  if (event.started) {
    return (
      <SummaryInProgress
        onSelectViewCurrent={onSelectViewCurrent}
        event={event}
        board={board}
      />
    );
  }
  // console.log("event.registrations :", event.registrations);
  return <SummaryScheduled event={event} board={board} />;
};
export default Summary;
